import { SxProp } from 'src/types/mui';

export const getDefaultPaperBorder: SxProp = theme => ({
  border: theme.constantStyles?.paperBorder,
  borderRadius: theme.constantStyles?.paperBorderRadius,
});
